Customer.Dashboard ||= {}

class Customer.Dashboard.TicketDetailsAttributesView extends Backbone.View
  className: 'ticket-details-attributes'
  template: JST["backbone/templates/customer/ticket/detail/box/ticket_details_attributes"]

  events:
    'click button#attributes-btn-cancel' : '_onCancel'
    'click button#attributes-btn-update' : '_onUpdate'

  initialize: (@options = {}) ->
    @ticket = @options.ticket
    @attributesCollection = @options.ticketAttributesCollection

  render: ->
    @$el.html(@template(ticket: @ticket))
    @conversationAttributesListView = new Customer.ConversationAttributesListView({
      collection: @attributesCollection,
      el: @$el.find('#conversation-attributes')
    })
    @_listenToJustOnce(@attributesCollection, 'change', @_onAttributeChange)
    @_listenToJustOnce(@conversationAttributesListView, 'conversation:attributes:update', @render)
    @listenTo(@conversationAttributesListView, 'custom_attributes:disable_save', @_disableSaveButton)
    @listenTo(@conversationAttributesListView, 'custom_attributes:enable_save', @_enableSaveButton)
    @$el.find('#conversation-attributes.nonEditable').on('click', @_onEdit)
    @listenTo(@conversationAttributesListView, 'conversation:attributes:edit', @_onEdit)
    @conversationAttributesListView.show()
    @delegateEvents()
    @

  _onEdit: =>
    @$el.find('#conversation-attributes').removeClass('nonEditable')
    @$el.find('.conversation-attributes-buttons').removeClass('hidden')

  _onCancel: ->
    @_disableEdition()
    @conversationAttributesListView._onCancel()

  _onUpdate: ->
    return unless @conversationAttributesListView.canUpdate()

    @_disableEdition()
    @conversationAttributesListView._onUpdate()

  _disableEdition: ->
    @$el.find('#conversation-attributes').addClass('nonEditable')
    @$el.find('.conversation-attributes-buttons').addClass('hidden')

  validateFieldsAreFilled: (fields) =>
    @attributesCollection.validateFieldsAreFilled(fields)

  isBeingModified: ->
    !@$el.find('#conversation-attributes').hasClass('nonEditable')

  _onAttributeChange: =>
    if @conversationAttributesListView.canUpdate()
      @_enableSaveButton()
    else
      @_disableSaveButton()

  _enableSaveButton: =>
    @_$saveButton().attr('disabled', false)

  _disableSaveButton: =>
    @_$saveButton().attr('disabled', true)

  _$saveButton: =>
    @$el.find('#attributes-btn-update')

  _listenToJustOnce: (object, name, callback) ->
    @stopListening(object, name, callback)
    @listenTo(object, name, callback)

  onAttributesValidationError: (ticketAttributeErrors) =>
    @conversationAttributesListView.onAttributesValidationError(ticketAttributeErrors)

  onTicketClose: =>
    @conversationAttributesListView.onTicketClose()
